<template>
  <div class="container">

    <section>
       <router-link to="/demos">Demos</router-link>
      /
      $popper.();
    </section>

    <h1 class="is-size-2 has-text-centered mb-5"><code>$popper.();</code> Demo</h1>
    <div class="columns">
      <div class="column is-one-third is-flex">
        <div class="box p-6">
          <p class="is-size-4 has-text-centered">Dropdowns</p>
          <hr>
          <div class="is-flex" id="filtersContainer">
            <!--  THE REST of the FILTERS (Custom Dropdowns) -->
            <div ref="flexedFilters" id="flexedFilters2" class="sortingFiltersContainer scrollContent is-flex" style="max-width: 280px;"
                 v-click-outside="forceClose_closeDropdownBox">
              <!-- SORT BY -->
              <section>
                <div ref="sortOrder">
                  <b-button
                      rounded
                      size="is-small"
                      :icon-right="'menu-down'"
                      :type="'is-outlined'"
                      @click="$popper.togglePopper($refs.sortOrder, $refs.sortButtons)"
                  >
                    Sort by
                  </b-button>
                </div>
                <div ref="sortButtons" class="filterBox popper-popup">
                  <FilterBoxHeader filter-name="Sort by" @closeFilterBox="forceClose_closeDropdownBox"/>
                  <LoremIpsum />
                </div>
              </section>
              <!-- AIRLINES -->
              <section>
                <div ref="selectedAirlines">
                  <b-button
                      rounded
                      size="is-small"
                      :icon-right="'menu-down'"
                      :type="'is-outlined'"
                      @click="$popper.togglePopper($refs.selectedAirlines, $refs.airlinesCBs)"
                  >

                    Airlines
                  </b-button>
                </div>
                <div ref="airlinesCBs" class="filterBox popper-popup">
                  <FilterBoxHeader filter-name="Airlines" @closeFilterBox="forceClose_closeDropdownBox"/>
                  <LoremIpsum />
                </div>
              </section>
              <!-- POLICY -->
              <section>
                <div ref="minPolicy">
                  <b-button
                      rounded
                      size="is-small"
                      :icon-right="'menu-down'"
                      :type="'is-outlined'"
                      @click="$popper.togglePopper($refs.minPolicy, $refs.policyCBs)"
                  >
                    Policy
                  </b-button>
                </div>
                <div ref="policyCBs" class="popper-popup filterBox ">
                  <FilterBoxHeader filter-name="Policy" @closeFilterBox="forceClose_closeDropdownBox"/>
                  <LoremIpsum />
                </div>
              </section>
              <!-- RATING -->
              <section>
                <div ref="minRating">
                  <b-button
                      rounded
                      size="is-small"
                      :icon-right="'menu-down'"
                      :type="'is-outlined'"
                      @click="$popper.togglePopper($refs.minRating, $refs.ratingCBs)"
                  >
                    Rating
                  </b-button>
                </div>
                <div ref="ratingCBs" class="popper-popup filterBox">
                  <FilterBoxHeader filter-name="Rating" @closeFilterBox="forceClose_closeDropdownBox"/>
                  <LoremIpsum />
                </div>
              </section>
            </div>
          </div>

          <hr>
          <div class="is-size-7">
            <p>Toggle Poppers with typical dropdown on <code>click trigger</code> <br>(+ dropdown header with X button to close the dropdown). </p>
            <br>
            <p><b>Note:</b> there is a directive attached to the container that allows for the dropdown to be toggled on outside click.</p>
          </div>
          <div class="is-clearfix"></div>
        </div>
      </div>

      <div class="column is-one-third is-flex">
        <div class="box p-6">
          <p class="is-size-4 has-text-centered">Tooltips</p>
          <hr>
          <!-- HOVER-->
          <section>
            <div ref="sortOrder3">
              <p>Hello,
                <span class="gant-text is-clickable"
                      @mouseenter="$popper.togglePopper($refs.sortOrder3, $refs.sortButtons3)"
                      @mouseleave="$popper.togglePopper($refs.sortOrder3, $refs.sortButtons3)"
                >hover over me!</span></p>
            </div>
            <div ref="sortButtons3" class="filterBox popper-popup" style="background: honeydew;">
              <p>Tooltip content - Can include any <code>HTML</code></p>
            </div>
          </section>

          <section class="mt-4">
            <div ref="sortOrder4">
              <button
                  @mouseenter="$popper.togglePopper($refs.sortOrder4, $refs.sortButtons4)"
                  @mouseleave="$popper.togglePopper($refs.sortOrder4, $refs.sortButtons4)">
                Hover this button
              </button>
            </div>
            <div ref="sortButtons4" class="filterBox popper-popup" style="background: hotpink;">
              <p>Tooltip content in hotpink :-) - Can include any <code>HTML</code></p>
            </div>
          </section>
        </div>
      </div>

      <div class="column is-one-third is-flex">
        <div class="box p-6">
          <p class="is-size-4 has-text-centered">Arrows</p>
          <hr>

          <div class="">
            <div class="column">
              <!-- ARROW LEFT -->
              <section class="is-inline-block ml-1 mr-1">
                <div ref="leftArrow">
                  <b-button
                      rounded
                      size="is-small"
                      :type="'is-outlined'"
                      v-on:click.stop.prevent="$popper.togglePopper($refs.leftArrow, $refs.leftMenu, leftArrowOptions)"
                  >
                    Arrow Left
                  </b-button>
                </div>
                <div ref="leftMenu" class="filterBox popper-popup" style="background: #333333;">
                  <ul>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                  </ul>
                  <div class="popper-arrow"></div>
                </div>
              </section>
            </div>
            <div class="column">
              <!-- ARROW RIGHT -->
              <section class="is-inline-block ml-1 mr-1">
                <div ref="rightArrow">
                  <b-button
                      rounded
                      size="is-small"
                      :type="'is-outlined'"
                      v-on:click.stop.prevent="$popper.togglePopper($refs.rightArrow, $refs.rightMenu, rightArrowOptions)"
                  >
                    Arrow Right
                  </b-button>
                </div>
                <div ref="rightMenu" class="filterBox popper-popup" style="background: #333333;">
                  <ul>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                  </ul>
                  <div class="popper-arrow"></div>
                </div>
              </section>
            </div>
          </div>

          <div class="">
            <div class="column">
              <!-- ARROW TOP -->
              <section class="is-inline-block ml-1 mr-1">
                <div ref="topArrow">
                  <b-button
                      rounded
                      size="is-small"
                      :type="'is-outlined'"
                      v-on:click.stop.prevent="$popper.togglePopper($refs.topArrow, $refs.topMenu, topArrowOptions)"
                  >
                    Arrow Top
                  </b-button>
                </div>
                <div ref="topMenu" class="filterBox popper-popup" style="background: #333333;">
                  <ul>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                  </ul>
                  <div class="popper-arrow"></div>
                </div>
              </section>
            </div>
            <div class="column">
              <!-- ARROW BOTTOM -->
              <section class="is-inline-block ml-1 mr-1">
                <div ref="bottomArrow">
                  <b-button
                      rounded
                      size="is-small"
                      :type="'is-outlined'"
                      v-on:click.stop.prevent="$popper.togglePopper($refs.bottomArrow, $refs.bottomMenu, bottomArrowOptions)"
                  >
                    Arrow Bottom
                  </b-button>
                </div>
                <div ref="bottomMenu" class="filterBox popper-popup" style="background: #333333;">
                  <ul>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                    <li><a href="#">menu item</a></li>
                  </ul>
                  <div class="popper-arrow"></div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <p class="is-size-4 has-text-centered">How to use</p>
      <p class="is-size-6 has-text-centered">Official Popper.js <a href="https://popper.js.org/docs/v2/" target="_blank">docs & tutorials</a>. </p>
      <hr>
      <p class="mt-4 mb-2">For usage and code samples, check files below:</p>
      <ul>
            <li>
              <code>src/components/Demos/PopperDemo.vue</code>
            </li>
            <li>
              <code>src/plugins/popper.js</code>
            </li>
            <li><code>src/assets/scss/_popper.scss</code></li>
          </ul>
      <div class="is-clearfix mb-4"></div>

<!--      <p class="mt-4 is-size-6">Regular tooltip/dropdown:</p>-->
<!--      <img src="/images/demos/popper_no_arrows.png" alt="popper" />-->
<!--      <div class="is-clearfix mb-4"></div>-->

<!--      <p class="mt-4 is-size-6">Dropdown/tootip with arrows:</p>-->
<!--      <img src="/images/demos/popper_with_arrows.png" alt="popper" />-->

      <pre><code v-pre>&lt;section class="is-inline-block ml-1 mr-1"&gt;
  &lt;!-- Popper Trigger  --&gt;
  &lt;div ref="popperButton">  &lt;!-- Add required REF for the Trigger  --&gt;
    &lt;b-button
        rounded
        size="is-small"
        :type="'is-outlined'"
        v-on:click.stop.prevent="$popper.togglePopper($refs.popperButton, $refs.popperContent, popperOptions)" &lt;!-- call $popper.togglePopper() method with both required $refs and optional options object  --&gt;
    >
      Arrow Top
    &lt;/b-button&gt;
  &lt;/div&gt;

  &lt;!-- Popper Content  --&gt;
  &lt;div&gt; ref="popperContent" class="filterBox popper-popup"&gt; &lt;!-- Add required REF for the Content  --&gt; &lt;!-- Add .popper-popup required class Content Box --&gt;
      &lt;ul&gt;
          &lt;li&gt;&lt;a href="#">menu item&lt;/a&gt;&lt;/li&gt;
          &lt;li&gt;&lt;a href="#">menu item&lt;/a&gt;&lt;/li&gt;
          &lt;li&gt;&lt;a href="#">menu item&lt;/a&gt;&lt;/li&gt;
          &lt;li&gt;&lt;a href="#">menu item&lt;/a&gt;&lt;/li&gt;
    &lt;/ul&gt;
    &lt;/ul&gt;
   &lt;div&gt; class="popper-arrow"&gt;&lt;/div&gt; &lt;!-- check src/assets/scss/_popper.scss for demo CSS and use as an example for your custom arrows  --&gt;
  &lt;/div&gt;
&lt;/section&gt;</code></pre>

    </div>

  </div>
</template>

<script>
  import FilterBoxHeader from "../Filters/FilterBoxHeader";
  import LoremIpsum from "./LoremIpsum";

  export default {
    name: "PopperDemo",
    components: {
      FilterBoxHeader,
      LoremIpsum,
    },
    data() {
      return {
        bottomArrowOptions: {
          placement: "bottom-start",
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            }
          ]
        },
        topArrowOptions: {
          placement: "top-start",
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            }
          ]
        },
        leftArrowOptions: {
          placement: "left-end",
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            }
          ]
        },
        rightArrowOptions: {
          placement: "right-end",
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            }
          ]
        },
      }
    },
    updated() {
      this.forceClose_closeDropdownBox();
    }
  }
</script>

<style scoped>

</style>